"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Icon = _interopRequireDefault(require("../Icon"));

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
var PIXELS_PER_CHAR = 6;

var CredentialToggle = function CredentialToggle(_ref) {
  var credential = _ref.credential,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["credential"]);
  var width = credential.length * PIXELS_PER_CHAR;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showClearText = _useState2[0],
      setShowClearText = _useState2[1];

  var classes = useStyles({
    props: {
      width: width,
      isTextVisible: showClearText
    }
  });

  var toggleView = function toggleView() {
    return setShowClearText(function (previousValue) {
      return !previousValue;
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classes.CredentialToggle
  }, rest), /*#__PURE__*/_react["default"].createElement("span", null, showClearText ? credential : '●●●●●●'), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: classes.Icon,
    "data-test-id": "credential-view-icon",
    glyph: showClearText ? 'eye-with-line' : 'eye',
    onClick: toggleView
  }));
};

var _default = CredentialToggle;
exports["default"] = _default;
//# sourceMappingURL=index.js.map